<template>
    <div> 
        <el-form ref="form" :model="form" :rules="rules" label-width="110px"> 
            <div style="margin-bottom:18px;">
                <el-radio v-model="form.setSwitch" label='1' @change="setSwitchEvent">开启自动升班</el-radio>
                <el-radio v-model="form.setSwitch" label='2' @change="setSwitchEvent">关闭自动升班</el-radio>
            </div>
            <el-form-item  prop="setDate" label="设置升班日期" style="width:250px;">
                <el-cascader
                    v-model="form.setDate"
                    :options="dates" separator="-" :disabled="isSetDate"></el-cascader>
            </el-form-item>
            <div style="font-size: 14px;color: rgba(25,31,37,.56);line-height: 22px;margin-bottom:18px;">
                升班后会发生什么？<br>
                1.年级名称自动升级，例如”一年级2018级”更名为”二年级2018级”<br>
                2.班级名称自动升级，例如“一年级1班”更名为“二年级1班”<br>
                3.各家校群的群名称自动升级（若群名称曾被群主修改过，则保持不变）<br>
                4.每个自然年仅支持升班1次，若成功升班后再修改时间，当年将不再生效<br>
            </div>
            
            <div class="graduateSet">批量毕业设置</div>
            <div style="font-weight: 700;font-size: 15px;color: #191f25;">以下是每个学段中的最高年级<span style="color:red;font-size:14px;font-weight: normal">（都不是，去"设置学段"那里设置）</span>：</div>
            <el-table
                :data="data"
                row-key="id"
                :show-header="showHeader"
                height="200"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-background = "rgba(255, 255,255,0.7)"
                highlight-current-row
                style="width: 100%">
                    <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                    <el-table-column property="maxGradeName" label="学段年级名称" ></el-table-column>
                    <el-table-column fixed="right" label="操作"  width="100"> 
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.status == 2"  
                                type="text"
                                size="small">
                                <span style="color: #add5fd;">已毕业</span>
                            </el-button>
                            <el-button v-else-if="scope.row.status == 0"  
                                type="text"
                                size="small">
                                <span style="color: #add5fd;">正在处理中</span>
                            </el-button>
                             <el-button v-else  
                                @click.native.prevent="updateGrade(scope.row)"
                                type="text"
                                size="small">
                                <span style="color: #387EE8;">毕业此年级</span>
                            </el-button>
                        </template>
                    </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
            <div style="font-size: 14px;color: rgba(25,31,37,.56);line-height: 22px;margin-bottom:18px;">
                毕业后会发生什么？<br>
                1. 毕业生和家长将被从“家校通讯录”批量移除，离开学校组织<br>
                2. 毕业生和家长将加入本校“校友会”的新组织，继续由校方统一管理，便于联系<br>
                3. 毕业的家校群将归属于“校友会”组织，历史数据保留，便于本班师生回顾<br>
            </div>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="save()">确 定</el-button>
        </span>
         
    </div>
</template>

<script>
    import http from '../../../../../common/http';

    export default {
        name:"",
        data(){
            return{
                showHeader:false,
                isSetDate:false,
                loading:false,
                loadingText:"",
                common:{
                    total:0,            //总数据量
                    pageSize:10,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[10,30], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    id:"",
                    setSwitch:'2',
                    setDate:[]
                },
                queryForm:{
                    id: "",
                    upgradeGradeName: ""
                },
                dates: [],
                data:[],
                rules: {
                    setDate: [
                        { required: true, message: '请选择设置升班日期', trigger: 'blur' }
                    ],
                }
            }
        },
        components: {
        },
        created:function () {
            this.intData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            intData(){
                // 初始表单数据
                let url  = this.archiveSeautoUpClassListUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                };

                this.loading = true
                this.loadingText = '数据加载中...'
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        // 初始每个学段中的最高年级,总数
                        this.common.total=res.data.stageMaxGradeTotal
                        this.data = res.data.stageMaxGradeList

                        // 初始设置升班日期
                        this.dates = res.data.dates
                        // 初始其他值
                        let resData=res.data.data
                        if(resData.length > 0){
                            this.form.id=resData[0].id
                            if(resData[0].setSwitch){
                                this.form.setSwitch='1'
                                this.form.setDate=resData[0].setDate.split("-")
                            }else{
                                this.form.setSwitch='2'
                            }
                        }else{
                            this.form.id=""
                            this.form.setDate=[]
                            this.form.setSwitch='2'
                        }
                        this.setSwitchEvent()
                        // console.log(JSON.stringify(res.data.data))

                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading = false
                },(err)=>{
                    this.loading = false
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val
                this.common.page = 1
                this.intData()
            },
            handleCurrentChange(val) {
                this.common.page = val
                this.intData()
            },
            setSwitchEvent(){
                if(this.form.setSwitch == '1'){
                    this.isSetDate=false
                }else{
                    this.isSetDate=true
                }
            },
            // 设置已毕业
            updateGrade(data){
                this.queryForm.id = data.id
                this.queryForm.upgradeGradeName = data.maxGradeName
                this.$commonFn.showConfirm2('毕业后，该年级将离开学校内部，转入新的校友会组织，便于学校对校友们统一管理和联系。是否确定毕业该年级？',this.updateGradeSuccess)
            },
            updateGradeSuccess(){
                let url  = this.archiveGradeUpdateUrl;
                let data = {
                    "id":this.queryForm.id,
                    "upgradeGradeName":this.queryForm.upgradeGradeName,
                }; 
                // console.log(JSON.stringify(data));
                // return;
                this.loading=true
                this.loadingText="数据处理中..."
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.$commonFn.showTip(res.message,1)
                        this.intData()
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                },(err)=>{
                    console.log(err)
                    this.loading=false
                });

            },
            // 保存配置
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url  = this.archiveSeautoUpClassSaveUrl
                        // 设置自动升班开关
                        let setSwitch=false
                        if(this.form.setSwitch == '1'){
                            setSwitch=true
                        }else{
                            setSwitch=false
                        }
                        // 设置升班日期-遍历数组
                        let setDate="";
                        if(setSwitch){
                            for(let i=0;i<this.form.setDate.length;i++){
                                if(setDate != ''){
                                    setDate+='-';
                                }
                                setDate+=this.form.setDate[i]
                            }
                        }

                        let data = {
                            "id":this.form.id,
                            "setSwitch":setSwitch,
                            "setDate":setDate
                        }; 
                        // console.log(JSON.stringify(data))
                        // return

                        this.loading=true
                        this.loadingText="数据保存中..."
                        this.apiPost(url,data).then((res) => {
                            if(res.status==200){
                                this.$commonFn.showTip(res.message,1)
                                this.intData()
                            }else{
                                this.$commonFn.showTip(res.message,3)
                            }
                            this.loading=false
                        },(err)=>{
                            console.log(err)
                            this.loading=false
                        });
                    }
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
.graduateSet {
    background: #eceff4;
    padding: 0 20px;
    min-height: 40px;
    line-height: 40px;
    margin-bottom:18px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/sys/dept/setclass/List.vue